import { ThemeButtonIcon } from '@shared/ui/buttons';
import { useAuth } from '@app/api/auth/useAuth';
import { useDialogContext } from '@app/components/dialogs/DialogProvider';

export default function LogoutDisplay() {
  const { logoutUser } = useAuth();
  const { closeModal } = useDialogContext();
  const handleLogout = async () => {
    try {
      await logoutUser();
      closeModal();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return <ThemeButtonIcon icon="logout" onClick={handleLogout} />;
}
